module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1218.4ab7b676.png";